<template>
    <div id="banner-element" :class="{empty: !moduleData}">
        <div class="module outwards" v-if="moduleData" :class="[moduleData.Spacing, moduleData.FullHeight ? 'full-height' : '']" :id="moduleData.AnchorID">
            <b-img-lazy class="shadow-heavy" v-if="moduleData.Image && moduleData.Image.ID" v-bind="imageProps" :src="moduleData.Image.URL" @load.native="imageLoaded = true"
                        :class="{loaded: imageLoaded}"></b-img-lazy>
            <div class="overlay" v-if="imageLoaded"></div>
            <div class="content-holder" v-if="imageLoaded" :class="moduleData.ContentPosition">
                <div class="wrapper">
                    <h2 v-if="moduleData.Title && moduleData.ShowTitle">{{moduleData.Title}}</h2>
                    <p v-if="moduleData.Content" v-html="moduleData.Content"></p>
                    <a class="btn btn-dark shadow-heavy" v-if="moduleData.CTA && moduleData.CTA.ID" :href="moduleData.CTA.URL">{{moduleData.CTA.CTAText}}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "BannerElement",
        data() {
            return {
                imageProps: {
                    center: true,
                    fluidGrow: true,
                    blank: true,
                    blankColor: '#fff'
                },
                imageLoaded: false
            }
        },
        props: {
            component: {
                type: Object,
            }
        },
        computed: {
            ...mapGetters(['getModuleData', 'getSettings']),
            moduleData() {
                return this.getModuleData(this.component.ID);
            }
        }
    }
</script>
